import $ from 'jquery';
import debounce from '../lib/utils/debounce';

const responsiveHeader = () => {
    const $window = $(window);
    const DESKTOP_BREAKPOINT = 1230;
    const MARGIN_LEFT = 30;
    const MAX_WIDTH = 1130;

    const selectors = {
        headerNavigation: '.js-header-desktop-navigation-wrap',
        visibleList: '.js-visible-list',
        visibleItem: '.js-visible-item',
        visibleLink: '.js-visible-link',
        hiddenList: '.js-hidden-list',
        hiddenItem: '.js-hidden-item',
        hiddenLink: '.js-hidden-link',
        pagesListHidden: '.js-pages-list--hidden'
    };

    const state = {
        hidden: 'hidden'
    };

    let isDesktopMenuInitialized = false;

    function renderHiddenItem(href, text) {
        const $newHiddenItem = $(
                `<li class="hidden-pages-dropdown__item js-hidden-item">
                    <a class="hidden-pages-dropdown__link js-hidden-link js-dropdown-link" href='${href}'>${text}</a>
                </li>`
        );

        $newHiddenItem.prependTo($(selectors.hiddenList));
    }

    function updateNav() {
        if ($window.width() < DESKTOP_BREAKPOINT || isDesktopMenuInitialized) {
            return;
        }

        let sumItemVisible = 0;
        const headerLogo = $('.header__lk-logo-link').width();
        const headerCartWrap = $('.header__cart-wrap').width() || 0;
        const headerEnterBtnWrap = $('.header__enter-btn-wrap').width() || 0;
        const headerProfileLabelWrap = $('.header__profile-label-wrap').width() || 0;
        const headerNotificationWrap = $('.header__notification-wrap').width() || 0;
        const headerComparisonWrap = $('.header__comparison-wrap').width() || 0;
        const spaceForNavigation = MAX_WIDTH - headerLogo - headerCartWrap - headerEnterBtnWrap - headerProfileLabelWrap - headerNotificationWrap - headerComparisonWrap - 20;

        $(selectors.headerNavigation).removeClass(state.hidden);

        $(selectors.visibleItem).each((index, item) => {
            sumItemVisible += $(item).width() + MARGIN_LEFT;
        });

        if (sumItemVisible < spaceForNavigation) {
            isDesktopMenuInitialized = true;
            return;
        }


        if (sumItemVisible > spaceForNavigation) {
            const $href = $(selectors.visibleList).children().last().find($(selectors.visibleLink)).attr('href');
            const $textLink = $(selectors.visibleList).children().last().find($(selectors.visibleLink)).text();

            renderHiddenItem($href, $textLink);

            $(selectors.pagesListHidden).removeClass(state.hidden);
            $(selectors.visibleList).children().last().remove();
            updateNav();
        }
    }

    updateNav();

    const setTargetHeader = debounce(() => {
        updateNav();
    }, 100);

    $(window).on('resize', () => {
        setTargetHeader();
    });

};

export default responsiveHeader;
